import $ from 'jquery';
import MCDatepicker from './datepicker';

export default class MCDatepickerGroup {
    constructor(selector) {
        this.$elem = $(selector);
        this.init();
    }

    async init() {
        this.isInitialized = true;

        if (!this.$elem.length) {
            this.isInitialized = false;
            return;
        }

        this.$elem.each((i, el) => {
            // eslint-disable-next-line no-new
            new MCDatepicker(el, i);
        });
    }
}
